import {
  Button,
  Card,
  Checkbox,
  DatePicker,
  Dialog,
  Input,
  Message,
  Pagination,
  Select,
  Switch,
  Table,
} from '@alifd/next';
import { Form, Image, Upload } from 'antd'; // dialog UI
import axios from 'axios';
import { format } from 'date-fns';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import ezconImg from '../../../../../public/ezcon.png';
import client from '../../../../lib/feathers';
import styles from './index.module.scss';

const Calendar = () => {
  const [form] = Form.useForm();
  // calendar 行事曆Table
  const calendar = client.service('calendar');
  const residentAccountNumbers = client.service('residentAccountNumbers');
  const [calendarArr, setCalendarArr] = useState([]);
  const [calendarObject, setCalendarObject] = useState({});
  // console.log("calendarArr",calendarArr)
  const [addCalendarDialog, setAddCalendarDialog] = useState(false);
  const [allows, setAllows] = useState([]);
  // console.log(allows)
  const [residentAccountNumbersArr, setResidentAccountNumbersArr] = useState(
    []
  );
  const [messageStatus, setMessageStatus] = useState(false);

  // sort
  const [curdataIndex, setcurDataIndex] = useState('selectTime');
  const [curorder, setcurOrder] = useState('asc');

  // 換頁
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(10);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = calendarArr.slice(indexOfFirstPost, indexOfLastPost);

  const currentDate = moment();
  const currentDate1 = moment().subtract(1, 'days');

  const [addCalendarDataType, setAddCalendarDataType] = useState('');
  const [isUpdate, setIsUpdate] = useState(false);
  const [addCalendarId, setAddCalendarId] = useState('');
  const [addAnnouncementType, setAddAnnouncementType] = useState('');

  useEffect(() => {
    residentAccountNumbers.find({}).then((res) => {
      setResidentAccountNumbersArr(res.data);
    });
  }, []);
  async function funFind(para) {
    const result = await calendar.find({ query: para });
    return result && result.data ? result.data : [];
  }
  async function funRemove(id) {
    await calendar.remove(id);
  }

  const serverDataUpdate = (dataIndex, order) => {
    const rdataIndex = dataIndex || curdataIndex;
    const rorder = order || curorder;

    funFind({}).then((result) => {
      setCalendarArr(
        result.sort((a, b) => {
          const result = (
            typeof a[rdataIndex] === 'number'
              ? a[rdataIndex].toString()
              : a[rdataIndex]
          ).localeCompare(
            typeof b[rdataIndex] === 'number'
              ? b[rdataIndex].toString()
              : b[rdataIndex]
          );
          return (rorder === 'asc') === result > 0 ? 1 : -1;
        })
      );
    });
  };
  const onTableSort = (dataIndex, order) => {
    console.log('==dataIndex:', dataIndex, 'order:', order);
    setcurDataIndex(dataIndex);
    setcurOrder(order);
    serverDataUpdate(dataIndex, order);
  };
  useEffect(() => {
    calendar.find({}).then((res) => {
      setCalendarArr(res.data);
    });
  }, [isUpdate, calendar]);

  // 推播棟別
  function allowsCheckBox() {
    const dataSource = [];

    for (let i = 0; i < residentAccountNumbersArr.length; i++) {
      // 第一層
      const building = residentAccountNumbersArr[i].building;
      // let householdNumber = residentAccountNumbersArr[i].householdNumber;
      let obj = dataSource.find((item) => item.label === building);
      if (!obj) {
        obj = {
          value: `${building}`,
          label: `${building}`,
        };
        dataSource.push(obj);
      }
    }

    return dataSource;
  }
  const disabledDate = (date, view) => {
    switch (view) {
      case 'date':
        return date.valueOf() <= currentDate1.valueOf();
      case 'year':
        return date.year() < currentDate.year();
      case 'month':
        return (
          date.year() * 100 + date.month() <
          currentDate.year() * 100 + currentDate.month()
        );
      default:
        return false;
    }
  };
  const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
  };
  // 圖片檔案上傳
  const uploadFiles = (dbName, file) => {
    const formData = new FormData();
    formData.append('files', file);
    const res = axios.post(
      '/newUploads?type=calendar&isConvertPng=true',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          authorization: localStorage.getItem('feathers-jwt'),
        },
      }
    );

    return res;
  };
  // 圖片刪除
  const deleteFile = (file) => {
    return client.service('uploads').remove(file.response._id);
  };

  // 新增修改公告
  const onFinish = async (values) => {
    const value = JSON.parse(JSON.stringify(values));
    console.log(value);
    let newData = {
      ...value,
      selectTime: moment(value.selectTime).valueOf(),
      allows,
    };
    if (!Object.prototype.hasOwnProperty.call(value, 'MessageStatus'))
      newData = { ...newData, MessageStatus: false };
    if (!Object.prototype.hasOwnProperty.call(value, 'content'))
      newData = { ...newData, content: '' };
    if (!Object.prototype.hasOwnProperty.call(value, 'files'))
      newData = { ...newData, files: [] };

    console.log(newData);

    if (addCalendarDataType === 'insert') {
      await calendar.create({
        ...newData,
      });
      Message.success('新增成功');
      setAddCalendarDialog(false);
      setIsUpdate((pre) => !pre);
    } else if (addCalendarDataType === 'update') {
      const res = await calendar.update(addCalendarId, {
        ...calendarObject,
        ...newData,
      });
      Message.success('更新成功');
      setAddCalendarDialog(false);
      setIsUpdate((pre) => !pre);
    }
  };

  return (
    <>
      <Button
        className={styles.buttonAdd}
        onClick={() => {
          setAddCalendarDialog(true);
          setAddCalendarDataType('insert');
          setAddAnnouncementType('');
          form.resetFields();
        }}
      >
        新增行事曆
      </Button>

      <Dialog
        hasMask
        shouldUpdatePosition
        className={styles.dialog}
        visible={addCalendarDialog}
        onOk={() => {
          form.submit();
        }}
        onCancel={() => {
          setAddCalendarDialog(false);
        }}
        onClose={() => {
          setAddCalendarDialog(false);
        }}
      >
        <div>
          <h3>{addCalendarDataType === 'insert' ? '新增' : '編輯'}行事曆</h3>
          <Form
            {...layout}
            onFinish={onFinish}
            form={form}
            className={styles.calenderForm}
          >
            <Form.Item
              name="selectTime"
              label="時間"
              rules={[
                {
                  required: true,
                  message: '請輸入時間',
                },
              ]}
            >
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                disabledDate={disabledDate}
              />
            </Form.Item>
            <Form.Item
              name="fileType"
              label="類型"
              rules={[
                {
                  required: true,
                  message: '請選擇類型',
                },
              ]}
            >
              <Select
                hasClear
                className={styles.options}
                placeholder="請選擇類型"
                onChange={(value) => setAddAnnouncementType(value)}
              >
                <Select.Option value="img">圖片</Select.Option>
                <Select.Option value="file">檔案</Select.Option>
                <Select.Option value="text">文字</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item
              name="title"
              label="標題"
              rules={[
                {
                  required: true,
                  message: '請輸入標題',
                },
              ]}
            >
              <Input
                name="title"
                placeholder="請輸入標題"
                maxLength={25}
                hasLimitHint
                aria-label="input max length 25"
              />
            </Form.Item>
            <Form.Item
              name="content"
              label="內容"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input.TextArea
                placeholder="請輸入內容"
                maxLength={500}
                rows={6}
                hasLimitHint
                aria-label="input max length 500"
              />
            </Form.Item>
            {addAnnouncementType !== 'text' && (
              <Form.Item
                name="files"
                valuePropName="fileList"
                label={
                  form.getFieldValue('fileType') === 'img'
                    ? '圖片上傳'
                    : '檔案上傳'
                }
                getValueFromEvent={(e) => {
                  const { fileList } = e;
                  return fileList;
                }}
                rules={[
                  {
                    validator: (_, value) => {
                      if (value) {
                        if (
                          value.map((item) => item.status).includes('uploading')
                        ) {
                          return Promise.reject(new Error('上傳中'));
                        }
                        if (
                          value.map((item) => item.status).includes('error')
                        ) {
                          return Promise.reject(
                            new Error('上傳失敗，請重新上傳或者移除檔案')
                          );
                        }
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Upload
                  fileList={form.getFieldValue('files')}
                  accept={
                    form.getFieldValue('fileType') === 'img'
                      ? 'image/*'
                      : '.doc,.docx,.pdf'
                  }
                  customRequest={async (options) => {
                    const { onSuccess, file } = options;
                    if (file.size > 1024 * 1024 * 20) {
                      Message.error('上傳檔案不能超過20MB');
                      return;
                    }
                    try {
                      const res = await uploadFiles(
                        'announcement',
                        options.file
                      );
                      onSuccess(res.data.length > 0 ? res.data[0] : res.data);
                    } catch (err) {
                      console.log(err);
                    }
                  }}
                  onRemove={async (file) => {
                    try {
                      await deleteFile(file);
                    } catch (err) {
                      console.error({ err });
                    }
                  }}
                >
                  <Button>上傳</Button>
                </Upload>
              </Form.Item>
            )}

            <Form.Item
              label="發佈推播"
              name="MessageStatus"
              valuePropName="checked"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Switch
                className={styles.messageSwitch}
                checkedChildren="開啟推播"
                unCheckedChildren="關掉推播"
                onChange={(checked) => {
                  if (checked === true) {
                    setMessageStatus(true);
                  } else {
                    setMessageStatus(false);
                    setAllows([]);
                  }
                }}
              />
            </Form.Item>
            {form.getFieldValue('MessageStatus') && messageStatus && (
              <Form.Item
                name="allows"
                label="推播住戶"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Checkbox.Group
                  className={styles.optionList}
                  itemDirection="ver"
                  dataSource={allowsCheckBox()}
                  onChange={async (value) => {
                    const res = await residentAccountNumbers.find({
                      query: { building: { $in: value } },
                    });
                    setAllows(res.data.map((item) => item.householdNumber));
                  }}
                />
              </Form.Item>
            )}
          </Form>
        </div>
      </Dialog>

      <Card free>
        <Card.Content>
          <Table dataSource={currentPosts} onSort={onTableSort}>
            <Table.Column
              sortable
              title="建立時間"
              dataIndex="createdTime"
              width={200}
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column
              sortable
              title="行事曆時間"
              dataIndex="selectTime"
              width={200}
              cell={(value) => moment(value).format('YYYY-MM-DD HH:mm:ss')}
            />
            <Table.Column sortable title="標題" dataIndex="title" width={200} />
            <Table.Column
              sortable
              title="內容"
              dataIndex="content"
              width={300}
            />

            <Table.Column
              title="照片"
              width={100}
              cell={(_value, _index, record) => {
                if (record.files) {
                  return (
                    <>
                      {record.files.map((list, index) => {
                        return (
                          <a
                            style={
                              list === ''
                                ? { display: 'none' }
                                : { display: 'block' }
                            }
                            target="_blank"
                            rel="noreferrer"
                            key={index}
                            href={list.response.showPath}
                          >
                            <span
                              role="img"
                              aria-label="spin"
                              aria-labelledby=""
                            >
                              📎
                            </span>
                            {` 附件${index + 1}`}
                          </a>
                        );
                      })}
                    </>
                  );
                }
              }}
            />

            <Table.Column
              title="操作"
              width={200}
              lock="right"
              cell={(_value, index, record) => {
                return (
                  <div>
                    <Button
                      className={styles.buttonEdit}
                      type="normal"
                      onClick={() => {
                        form.setFieldsValue({
                          ...record,
                          selectTime: moment(record.selectTime),
                        });
                        setAddCalendarDataType('update');
                        setAddCalendarId(record._id);
                        setAddCalendarDialog(true);
                        setAddAnnouncementType(record.fileType);
                        setCalendarObject(record);
                      }}
                    >
                      編輯
                    </Button>

                    <Button
                      type="primary"
                      warning
                      onClick={() => {
                        const item = currentPosts[index];
                        Swal.fire({
                          title: `確定刪除標題(${record.title})資料?`,
                          text: '刪除後將無法復原!!',
                          icon: 'warning',
                          showCancelButton: true,
                          confirmButtonColor: '#3085d6',
                          cancelButtonColor: '#BEBEBE',
                          confirmButtonText: '確定',
                          cancelButtonText: '取消',
                        }).then((result) => {
                          if (result.isConfirmed) {
                            Swal.fire('刪除!', '此筆資料已刪除', 'success');
                            funRemove(item._id).then(() => {
                              const prePages =
                                currentPage - 1 >= 0 ? currentPage - 1 : 0;
                              // console.log("prePages",prePages)
                              if (
                                calendarArr.length - 1 <=
                                prePages * postsPerPage
                              ) {
                                // console.log("123",currentPage -1 < 1 ? 1 : currentPage -1  )
                                setCurrentPage(
                                  currentPage - 1 < 1 ? 1 : currentPage - 1
                                );
                              }
                              serverDataUpdate();
                            });
                          }
                        });
                      }}
                    >
                      刪除
                    </Button>
                  </div>
                );
              }}
            />
          </Table>

          <Pagination
            className={styles.pagination}
            total={calendarArr.length}
            pageSize={postsPerPage}
            totalRender={(total) => `Total: ${total}`}
            onChange={(pageNumber) => {
              setCurrentPage(pageNumber);
            }}
          />
        </Card.Content>
      </Card>
    </>
  );
};

export default Calendar;
